var __toastMarkup = `
<div class="position-fixed top-50 end-0 translate-middle-y pop-up-wishlist-wrapper" >
		<div aria-atomic="true d-flex" aria-live="polite" class="toast hide" id="swym-toast" role="alert">
			<div class="toast-header">
				 <strong class="me-auto">Item added to Wishlist</strong>
			</div>
			<div class="toast-body">
			<div class="wishlist-prod-info">
			<a class="container-img-wishlist-popup" href="{{du}}">
				<img alt="Image" class="img-wishlist-pop-up" src="{{iu}}" style=>
			</a>
            	<div class="">
				<h3 class="text-wishlist-popup h4">{{dt}} - {{variantInfo}}<br><br>{{cu}}{{pr}}</h3>
				
				</div>
		    </div>
			<div class="cta-wishlist-wrapper">
                <a class="button" href="#" id="openWl">View Wishlist</a>
				<button aria-label="Close" class="close-btn-wishlist"data-bs-dismiss="toast" type="button">Back to shopping</button>


			</div>
			</div>
		</div>
	</div>`;

function swymCallbackFn(swat) {
  //   Toast Options - Set Autohide to true, to hide after delay.
  let options = {
    autohide: true,
    delay: 6000,
    animation: true
  };

  function showCustomNotification(event) {
    var parentContainer = document.querySelector("#swym-custom-notify-container");
    var product = event.detail.d;
    if (parentContainer && bootstrap.Toast) {
      parentContainer.innerHTML = ""; // Reset old toasts;
      product = SwymUtils.formatProductPrice(product);
      product.variantInfo = getVariantInfo(product.variants);
      let toastDetails = SwymUtils.renderTemplateString(__toastMarkup, product);
      parentContainer.innerHTML = toastDetails;
      let toastElement = document.querySelector("#swym-toast");
      let toast = new bootstrap.Toast(toastElement, options);
      toast.show();
      bindEvent();

      function bindEvent() {
        document.getElementById('openWl').onclick = function() {
          swat.ui.open();
        }
      }
    }

    function getVariantInfo(variants) {
      try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(variants[0]) : []),
            variantinfo;
        if (variantKeys.length) {
          variantinfo = variantKeys[0];
        }
        return (variantinfo == "Default Title") ? "" : variantinfo;
      } catch (err) {
        return variants;
      }
    }
  }
  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function(event) {
    //Show custom Notifications on event;	
    showCustomNotification(event);
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);